var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LinkButtonWrapper",
    {
      attrs: {
        to: _vm.$props.to,
        href: _vm.$props.href,
        target: _vm.$props.target,
        adaptiveWidth: _vm.$props.adaptiveWidth,
      },
    },
    [
      _c(
        "div",
        { staticClass: "scidButton" },
        [
          _c("p", { staticClass: "scidButton__label" }, [
            _vm._v(_vm._s(_vm.$props.label)),
          ]),
          _c("ScidIcon", { staticClass: "scidButton__icon" }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }